import type { Auth0Organization, VendorOrganizationInput, VendorOrganizationMapping } from '@/types/vendorOrganization';
import apiClient from './axios';

export async function fetchVendorOrganizations(): Promise<VendorOrganizationMapping[]> {
  const { data } = await apiClient.get<VendorOrganizationMapping[]>('/admin/vendor-organizations', {
    skipGlobalError: true,
  });
  return data;
}

export async function createVendorOrganization(input: VendorOrganizationInput): Promise<VendorOrganizationMapping> {
  const { data } = await apiClient.post<VendorOrganizationMapping>('/admin/vendor-organizations', input, {
    skipGlobalError: true,
  });
  return data;
}

export async function deleteVendorOrganization(id: string): Promise<void> {
  await apiClient.delete(`/admin/vendor-organizations/${id}`, { skipGlobalError: true });
}

export async function fetchAuth0Organizations(): Promise<Auth0Organization[]> {
  const { data } = await apiClient.get<Auth0Organization[]>('/admin/auth0-organizations', { skipGlobalError: true });
  return data;
}
